import ChannelTree from '@/data/ChannelTree';
import NavigationTree from '@/data/NavigationTree';

export default class UiChannelTree extends NavigationTree {
  
  public static init(channelTree: ChannelTree, uiChannelTree: UiChannelTree, context: any): void {
    
    uiChannelTree.id = channelTree.id;
    uiChannelTree.isOpen = false;
    uiChannelTree.name = channelTree.name;
    uiChannelTree.nameLocalized = channelTree.nameLocalized;
   
    for(const childChannelTree of channelTree.children) {
      const uiChildChannelTree = new UiChannelTree(
        childChannelTree.id, uiChannelTree.level + 1, childChannelTree.parentId, uiChannelTree);
      UiChannelTree.init(childChannelTree, uiChildChannelTree, context);
      uiChannelTree.children.push(uiChildChannelTree);
    }
  }

  constructor(id: number, level: number, parentId: number, parentTree: UiChannelTree | undefined) {
    super(id, level, parentId, parentTree);
  }

  public initFrom(channelTree: ChannelTree, context: any) {
    this._children = [];
    UiChannelTree.init(channelTree, this, context);
  }

  public hasOpenSubTree(): boolean {
    for(const subChannelTree of this.children) {
      if(subChannelTree.isOpen) {
        return true;
      }
    }
    return false;
  }

  public longestWord(currentValue: string): string {
    return this._longestWord(currentValue);
  }

  private _longestWord(currentValue: string): string {
    
    for(const subChannelTree of this.children) {
      
      if(subChannelTree.nameLocalized.length > currentValue.length) {
        currentValue = subChannelTree.nameLocalized;
      }
      currentValue = (subChannelTree as UiChannelTree).longestWord(currentValue);
    }
    if(this.nameLocalized.length > currentValue.length) {
      currentValue = this.nameLocalized;
    }
    
    return currentValue;
  }

}
